import { render, staticRenderFns } from "./customer_details.vue?vue&type=template&id=f9b4fc28&scoped=true"
import script from "./customer_details.vue?vue&type=script&lang=js"
export * from "./customer_details.vue?vue&type=script&lang=js"
import style0 from "./customer_details.vue?vue&type=style&index=0&id=f9b4fc28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b4fc28",
  null
  
)

export default component.exports